/**
 * Calculates the lower bound for a loan amount range based on specific business rules
 * @param loanAmount - The maximum loan amount (upper bound)
 * @returns The calculated lower bound
 */
export function calculateLoanLowerBound(loanAmount: number) {
  if (!loanAmount || loanAmount <= 0) {
    return 0;
  }

  // Calculate 8% less than the upper bound
  const eightPercentLess = loanAmount * 0.92;

  // Round to the nearest €1,000
  const roundedToThousand = Math.round(eightPercentLess / 1000) * 1000;

  // Ensure lower bound doesn't exceed the loan amount
  return Math.min(roundedToThousand, loanAmount);
}
